import { HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CaptureBigNumbers } from '../BigNumbers/components/CaptureBigNumbers';
import { FinancialAnalysis } from '../FinancialAnalysis';
import { FinancialSummary } from '../FinancialSummary';
import { FundraisingAnalysis } from '../FundraisingAnalysis';
import { LeadCaptureAndConversionProps } from '../LeadCaptureAndConversion';
import { MyShortcuts } from '../MyShortcuts';
import { Top15Products } from '../Top15Products';

export const LeadCapture: React.FC<LeadCaptureAndConversionProps> = ({ isMobile, isTablet }) => {
  const financialSummaryAndTop15ProductsComponent = useBreakpointValue({
    base: <MyShortcuts />,
    sm: (
      <HStack
        paddingX={Spacing['stack.xxxs']}
        space={Spacing['stack.xxxs']}
        direction={isTablet ? 'column' : 'row'}>
        <FinancialSummary isMobile={isMobile} />
        <Top15Products isMobile={isMobile} />
      </HStack>
    ),
  });

  return (
    <VStack>
      <CaptureBigNumbers isMobile={isMobile} />
      <VStack space={Spacing['stack.xxxs']}>
        <FundraisingAnalysis isMobile={isMobile} />
        {financialSummaryAndTop15ProductsComponent}
        <FinancialAnalysis isMobile={isMobile} />
      </VStack>
    </VStack>
  );
};
